import ConflictModal from './ConflictModal'
import conflictModalContainer from './conflictModalContainer'

export default conflictModalContainer(ConflictModal)
